import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

const DashboardHeading = ({ title }: { title: string }) => {
  return (
    <Flex paddingY='4' bgColor='#F5F6FA' justifyContent='center'>
      <Text fontSize='3xl'>{title}</Text>
    </Flex>
  )
}

export { DashboardHeading }
